import { WARMTH_COLORS, stageOf } from "@/components/sales/constants";

export const WarmthBadge = ({ w, testid }) => {
  if (!w) return <span className="rounded-full bg-white/5 px-2.5 py-0.5 text-xs text-muted-foreground" data-testid={testid}>Not scored</span>;
  const c = WARMTH_COLORS[w.label] || "#94a3b8";
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold" style={{ background: `${c}1f`, color: c }} data-testid={testid}>
      {w.score != null && <span className="font-mono">{w.score}</span>} {w.label}
    </span>
  );
};

export const StageBadge = ({ stage }) => {
  const s = stageOf(stage);
  return <span className="rounded-full px-2.5 py-0.5 text-xs font-semibold" style={{ background: `${s.color}1f`, color: s.color }}>{s.label}</span>;
};

export const SalesHeader = ({ title, subtitle, children }) => (
  <div className="fade-up mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-cyan-400">Sales</p>
      <h1 className="mt-2 font-display text-4xl font-extrabold tracking-tight" data-testid="sales-page-title">{title}</h1>
      {subtitle && <p className="mt-2 max-w-2xl text-sm text-muted-foreground">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Btn = ({ children, variant = "ghost", className = "", ...p }) => {
  const v = variant === "primary" ? "bg-primary text-primary-foreground hover:bg-white" : variant === "cyan" ? "bg-cyan-400 text-black hover:bg-cyan-300" : "border hover:bg-white/5";
  return <button {...p} className={`inline-flex h-10 items-center gap-2 rounded-full px-4 text-sm font-semibold transition-colors disabled:opacity-50 ${v} ${className}`}>{children}</button>;
};
